import { css, type Theme } from "@emotion/react";

export const card = (theme: Theme) => css`
  background-color: ${theme.ds5.surface.level0};
  border: ${theme.ds5.box.borderWeight} solid ${theme.ds5.neutral.divider};
  border-radius: ${theme.ds5.radius.surface.xlarge};
`;

export const identity = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.medium};
  padding: ${theme.ds5.padding.static[600]};
`;

export const divider = css`
  margin: 0;
`;

export const pricing = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.gap[300]};
  padding: ${theme.ds5.padding.static[500]} ${theme.ds5.padding.static[600]};
`;

export const pricingRow = (theme: Theme) => css`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const firstVisitPrice = (theme: Theme) => css`
  color: ${theme.ds5.success.text};
`;
